/* eslint-disable */
import { MODALS } from '@/components/app/app-modals/app-modals';
import { ONBOARDING_STEPS, ONBOARDING_STEP_NAME_CODE_MAP, ONBOARDING_STEP_CODE_NAME_MAP } from '@/components/onboarding/consts';
import log from '@/logger';
import { loginUrl, signUpUrl } from '@/utils/helpers';


export default {
  namespaced: true,
  state: {
    editModeOn: false,
    currentStep: ONBOARDING_STEPS.REGISTER,
  },
  mutations: {
    setCurrentStep(state, step) {
      state.currentStep = step;
    },
    setOnboardingEditMode(state, flag) {
      state.editModeOn = flag;
    },
  },
  actions: {
    showOnboardingStepByCode({ dispatch, rootGetters }, { stepCode }) {
      log.info(`[ONBOARDING] showOnboardingStepByCode ${stepCode}`);
      if (stepCode === ONBOARDING_STEP_NAME_CODE_MAP.ADD_FUNDS_OR_PENDING) {
        const step = rootGetters['user/showComplianceReviewBanner'] ?
          ONBOARDING_STEPS.PENDING_APPROVAL :
          ONBOARDING_STEPS.QUICK_DEPOSIT;
        dispatch('showOnboardingStep', { step });
      } else {
        dispatch('showOnboardingStep', { step: ONBOARDING_STEP_CODE_NAME_MAP[stepCode] });
      }
    },
    showOnboardingStep({ commit, dispatch, rootGetters }, { step }) {
      if (step === ONBOARDING_STEPS.LOGIN) {
        dispatch('popup/setCurrentPopup', null, { root: true });
        if (rootGetters['app/isLoginEnabled']) {
          alert('login');
        } else {
          dispatch('popup/setCurrentSmallPopup', MODALS.SMALL_PROCESS_ERROR, { root: true });
          dispatch('popup/setCurrentPopupOptions', { message: 'Due to site maintenance, it\'s not possible to log in at this time. Please try again later.' }, { root: true });
        }

        return Promise.resolve(1);
      } else if (step === ONBOARDING_STEPS.REGISTER) {
        dispatch('popup/setCurrentPopup', null, { root: true });
        if (rootGetters['app/isSignUpEnabled']) {
          alert('logout');
        } else {
          dispatch('popup/setCurrentSmallPopup', MODALS.SMALL_PROCESS_ERROR, { root: true });
          dispatch('popup/setCurrentPopupOptions', { message: 'Due to site maintenance, it\'s not possible to sign up at this time. Please try again later.' }, { root: true });
        }
        return Promise.resolve(1);
      }
      log.info(`[ONBOARDING] showOnboardingStep ${step}`);
      commit('setCurrentStep', step);
      return dispatch('popup/setCurrentPopup', MODALS.ONBOARDING, { root: true });
    },
    setCurrentStep({ commit }, { step }) {
      commit('setCurrentStep', step);
    },
    setOnboardingEditMode({ commit }, flag) {
      commit('setOnboardingEditMode', flag);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/onboarding.js